import {
  Event,
  NavigationEnd,
} from '@angular/router';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  startWith,
} from 'rxjs/operators';

/**
 * Returns the current location href
 * `router.events` is used as trigger to grab the new values from `document.location`
 * `filter` operator acts as a rate-limiter, the only interesting event is the `NavigationEnd` event
 */
export const retrieveLocationHref = () => (source: Observable<Event>) =>
  source.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => document.location.href),
    distinctUntilChanged(),
    startWith(document.location.href)
  );

/**
 * Returns the current location origin
 * `router.events` is used as trigger to grab the new values from `document.location`
 * `filter` operator acts as a rate-limiter, the only interesting event is the `NavigationEnd` event
 */
export const retrieveLocationOrigin = () => (source: Observable<Event>) =>
  source.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => document.location.origin),
    distinctUntilChanged(),
    startWith(document.location.origin)
  );

/**
 * Returns the current location pathname
 * `router.events` is used as trigger to grab the new values from `document.location`
 * `filter` operator acts as a rate-limiter, the only interesting event is the `NavigationEnd` event
 */
export const retrieveLocationPathname = () => (source: Observable<Event>) =>
  source.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => document.location.pathname),
    distinctUntilChanged(),
    startWith(document.location.pathname)
  );
